import { format, getTime, formatDistanceToNow, addMonths, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';

// ----------------------------------------------------------------------

type InputValue = Date | string | number | null;

export function fDate(date: InputValue, newFormat?: string) {
  const fm = newFormat || 'dd MMM yyyy';
  return date ? format(parseISO(String(date)), fm, { locale: ptBR }) : '';
}

export function fDateTime(date: InputValue, newFormat?: string) {
  const fm = newFormat || 'dd MMM yyyy p';
  return date ? format(new Date(date), fm, { locale: ptBR }) : '';
}

export function fTimestamp(date: InputValue) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date: InputValue) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
        locale: ptBR,
      })
    : '';
}

export function fAddMonthsISO(date: InputValue, months: number): string {
  if (!date) return '';
  const result = addMonths(new Date(date), months);
  return result.toISOString();
}
